<!-- =========================================================================================
  File Name: DataViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} MANAGER</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <template >

          <!-- Image Container -->
         <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">

            <img v-if="checkImg" :src="dataImg" class="responsive">
          </div>
          </div>
            </div>
          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} Image</vs-button>
            <vs-button v-if="ImgName!==null" type="flat" color="#999" @click="ImgName = null , dataImg = null">Remove Image</vs-button>
          </div>
        </template>

        <!-- FIRST NAME -->
        <vs-input label="First Name *" v-model="dataFirstName" class="mt-5 w-full" name="firstName" v-validate="'required'"/>

        <!-- LAST NAME -->
        <vs-input label="Last Name *" v-model="dataLastName" class="mt-5 w-full" name="lastName" v-validate="'required'"/>
        <!-- NICK NAME -->
        <vs-input label="Nickname" v-model="dataNickName" class="mt-5 w-full" name="Nick Name" />
        <!-- Username -->
        <vs-input label="Username *"  v-model="dataUserName" @input="checkUserName" class="mt-5 w-full" name="UserName"  v-validate="'alpha_num'"/>
        <span class="text-danger text-sm" v-show="errors.has('UserName')">{{ errors.first('UserName') }}</span>

        <span class="text-danger text-sm" v-if="UserDuplicate>0">Username has already been taken !</span>
        <!-- EMAIL -->
        <vs-input label="Email *" v-model="dataEmail" @input="checkUserEmail" class="mt-5 w-full" name="email"
                  v-validate="'email|required'"/>
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        <span class="text-danger text-sm" v-if="emailDuplicate>0">Email has already been taken !</span>

        <!-- PHONE -->
        <vs-input label="Phone"  v-model="dataPhone" @input="acceptNumber" class="mt-5 w-full" name="phone"/>
        <span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
        <span v-if="dataPhone.length > 0 &&  dataPhone.length < 14" class="text-danger text-sm">Invalid phone number format.</span>

        <br>
        <label>Locations</label><br> <br>
        <!--        <v-select    multiple :closeOnSelect="false" v-model="selected" :options="options" :dir="$vs.rtl ? 'rtl' : 'ltr'" /> <br>-->
        <!-- EMAIL CONFIRMED STATUS -->
        <vs-checkbox v-for="location in locations" :key="location.id" :vs-value="location.id" v-model="dataLocation">
          {{ location.name }}
        </vs-checkbox>

        <br>

        <!-- Send Invite Email -->

        <vs-checkbox v-show="enableInvitOption" v-model="dataEmailInviteOption"
                     @change="changeEmailConfirmationStatus(dataEmailInviteOption)">Send Invite Email
        </vs-checkbox>

<!--        <vs-row vs-w="12" class="ml-6">-->
<!--          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="2" vs-xs="2">-->
<!--            <label>Email Confirmed</label>-->
<!--          </vs-col>-->
<!--          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="8">-->
<!--          </vs-col>-->
<!--          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="1">-->

<!--            <vs-switch v-model="dataEmailConfirmed" @change="changeInviteEmailStatus(dataEmailConfirmed)"></vs-switch>-->
<!--          </vs-col>-->
<!--        </vs-row>-->
        <div v-if="!dataEmailInviteOption">
        <vs-input
          ref="password"
          type="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:20'"
          name="password"
          label-placeholder="Password"
          placeholder="Password"
          v-model="dataPassword"
          class="w-full mt-6" />
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>

        <vs-input
          type="password"
          v-validate="'min:6|max:20|confirmed:password'"
          data-vv-validate-on="blur"
          data-vv-as="password"
          name="confirm_password"
          label-placeholder="Confirm Password"
          placeholder="Confirm Password"
          v-model="dataConfPassword"
          class="w-full mt-6" />
        <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

        </div>
<br>

        <!-- STATUS -->
        <vs-row vs-w="12" class="ml-6">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="2" vs-xs="1">
            <label>Status</label>
          </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="9">
        </vs-col>  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="1">
          <vs-switch v-model="dataStatus"></vs-switch>
        </vs-col>
        </vs-row>


      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import {
  ALL_LOCATIONS,
  CHECK_USER_EMAIL,
  CREATE_MANAGER,
  SINGLE_USER_BY_EMAIL,
  SINGLE_USER_BY_USERNAME,
  UPDATE_MANAGER,
  CHECK_USER_NAME_EXCEPT_ID, UPLOAD_IMAGE
} from "@/graphql";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
  },
  data () {
    return {
      locations:[],
      dataId: null,
      ImgName:'',
      dataImg:'',
      oldimage:'',
      dataFirstName: '',
      dataLastName: '',
      dataNickName: '',
      dataUserName: '',
      dataEmail: '',
      dataPhone: '',
      checkImg:'',
      dataLocation: [],
      dataStatus: true,
      dataPassword: '',
      dataConfPassword: '',
      dataEmailConfirmed: false,
      dataEmailInviteOption: true,
      PassField: true,
      UserDuplicate: 0,
      emailDuplicate: 0,
      selected: ['Staten Island', 'Manhattan'],
      enableInvitOption: true,
      location_choices: [
        {text: 'Derek Shaw', value: 'Derek Shaw'},
        {text: 'John Whick', value: 'John Whick'},
        {text: 'Brian Gold', value: 'Brian Gold'}
      ],

      options: ['Staten Island', 'Manhattan', 'Broko'],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.PassField=true
        this.enableInvitOption=true

      } else {
        const { id, avatar,fname,lname,username,nick_name, status, email, phone, managerlocations,email_confirmed } = JSON.parse(JSON.stringify(this.data))
        this.PassField = false
        this.dataId = id
        this.dataImg = this.img_cdn+avatar
        this.ImgName = avatar
        this.oldimage = avatar
        this.checkImg = avatar
        this.dataFirstName = fname
        this.dataLastName = lname
        this.dataNickName = nick_name
        this.dataUserName = username
        this.dataEmail = email
        this.dataPhone = phone
        if(!this.dataPhone){
          this.dataPhone=''
        }
        this.dataLocation = managerlocations.map(function (value, index) {
          return value.id;
        });
        this.dataEmailConfirmed = email_confirmed
        this.dataStatus = status

        this.dataPassword = ''
        this.dataConfPassword = ''
        this.initValues()
        this.enableInvitOption = false
      }
    }
  },
  computed: {
    // locations () {
    //   return this.$store.state.dataList.locations
    // },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      if(this.PassField){
        return !this.errors.any() && this.dataEmail && this.dataFirstName && this.dataLastName && this.dataUserName  && this.UserDuplicate === 0 && this.emailDuplicate === 0 && (this.dataPhone =='' || this.dataPhone.length ==14)
      }
      else{
        return !this.errors.any() && this.dataEmail && this.dataFirstName && this.dataLastName && this.dataUserName && (this.dataPhone =='' || this.dataPhone.length ==14)
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
     openLoadingInDiv(){
      this.$vs.loading({
        type:'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    checkUserName() {
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkUserNameExcepteId();
      } else {
        this.checkUserNameWithoutId()
      }
    },
    checkUserNameExcepteId() {
      var letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUserName.match(letterNumber)) {
      } else {
        if (this.dataUserName) {
          this.$apollo
            .mutate({
              mutation: CHECK_USER_NAME_EXCEPT_ID,
              variables: {
                id: this.dataId,
                username: this.dataUserName,
              },
            })
            .then(response => {
              this.UserDuplicate=response.data.checkUserNameExceptId.length
            })
        }
      }
    },
    checkUserNameWithoutId() {
      var letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUserName.match(letterNumber)) {
      } else {
        if (this.dataUserName) {
          this.$apollo
            .mutate({
              mutation: SINGLE_USER_BY_USERNAME,
              variables: {
                username: this.dataUserName,
              },
            })
            .then(response => {
              this.UserDuplicate=response.data.userByUserName.length
            })
        }
      }
    },

    checkUserEmail() {
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkEmailExceptId();
      } else {
        this.checkEmailWithoutId()
      }
    },

    checkEmailExceptId() {
      this.$apollo
        .mutate({
          mutation: CHECK_USER_EMAIL,
          variables: {
            id: this.dataId,
            email: this.dataEmail,
          },
        })
        .then(response => {
          this.emailDuplicate = response.data.checkUserEmail.length
        })
    },
    checkEmailWithoutId() {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email: this.dataEmail,
          },
        })
        .then(response => {
          this.emailDuplicate = response.data.userByEmail.length
        })
    },
    acceptNumber() {
      let x = this.dataPhone
        .replace(/\D/g, "")
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);

      this.dataPhone = !x[2]
        ? x[1]
        : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
    },
    SuccessfullyCreatedNotification() {
      this.$vs.notify({
        title: "Manager",
        text: 'Created  Successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    SuccessfullyUpdatedNotification() {
      this.$vs.notify({
        title: "Manager",
        text: 'Updated  Successfully',
        color: 'success',
        position: 'top-right'
      })
    },
    StatusInvalid() {

      this.$vs.notify({
        title: "Invalid Data",
        text: '',
        color: 'danger',
        position: 'top-right'
      })

    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataImg = '',
      this.ImgName = null,
      this.oldimage ='',
      this.dataFirstName = ''
      this.dataLastName = ''
      this.dataNickName = ''
      this.dataUserName = ''
      this.dataLocation = []
      this.dataStatus = true
      this.dataEmailConfirmed = false
      this.dataEmail = ''
      this.dataPhone = ''
      this.dataPassword = ''
      this.dataConfPassword = ''
       this.checkImg=''
      this.selected = [
        'Staten Island'
      ]

    },
    changeEmailConfirmationStatus(val) {
      this.dataEmailConfirmed = !val
      this.dataPassword=''
      this.dataConfPassword=''
    },
    changeInviteEmailStatus(val) {
      this.dataEmailInviteOption = !val
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_MANAGER,
                variables: {
                  id: this.dataId,
                  avatar: this.ImgName,
                  fname: this.dataFirstName,
                  lname: this.dataLastName,
                  nick_name: this.dataNickName,
                  username: this.dataUserName,
                  phone: this.dataPhone,
                  email: this.dataEmail,
                  status: this.dataStatus,
                  locations: this.dataLocation,


                }
              }).then(response => {
              if(response.data.updateManager.status=='SUCCESS'){
                this.SuccessfullyUpdatedNotification()
              }
            }).catch(error => {
              this.StatusInvalid()
            });
          } else {

            this.$apollo
              .mutate({
                mutation: CREATE_MANAGER,
                variables: {
                  avatar: this.ImgName,
                  fname: this.dataFirstName,
                  lname: this.dataLastName,
                  nick_name: this.dataNickName,
                  username: this.dataUserName,
                  phone: this.dataPhone,
                  email: this.dataEmail,
                  status: this.dataStatus,
                  email_confirmed:true,
                  locations: this.dataLocation,
                  invite_email :this.dataEmailInviteOption,
                  password: this.dataPassword,
                }
              }).then(response => {
              if(response.data.createManager.status=='SUCCESS'){
                this.SuccessfullyCreatedNotification()
              }
              else if(response.data.createManager.status=='MUST_VERIFY_EMAIL'){
                this.SuccessfullyCreatedNotification()
              }
            }).catch(error => {
              this.StatusInvalid()
            });
          }

          this.$emit('closeSidebar')
          this.initValues()
        }
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        this.checkImg="somthing"
        const reader = new FileReader()
         reader.onload = e => {
          this.dataImg = e.target.result
          this.openLoadingInDiv();
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image:this.dataImg,
                oldimage:this.oldimage,
              }
            })
            .then(response => {
              if (response){
                this.oldimage=''
                if(response.data.uploadImage.status=="SUCCESS"){
                  this.ImgName = response.data.uploadImage.image_name
                  this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                }
                else{
                  this.ImgName = response.data.uploadImage.image_name
                  this.UploadFail(response.data.uploadImage.error)
                  this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                }

              }
            }) .catch(error => {
            console.log(error)
          });
        }
        reader.readAsDataURL(input.target.files[0])
      }
    }
  },
  created () {
    this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
    this.$apollo
      .mutate({
        mutation: ALL_LOCATIONS,
      })
      .then(response => {
        this.locations=response.data.locations
      })
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
